module.exports = __webpack_public_path__ + "static/media/loading.3899f2ad.gif";